<mat-card>

  <mat-card-content>

    <mat-card-title style="margin:10px" *ngIf="invoiceConfiguration">Dati Progetto</mat-card-title>
    <ct-form *ngIf="mainConfiguration" [configuration]="mainConfiguration"></ct-form>
    <mat-card-title style="margin:10px" *ngIf="invoiceConfiguration">Dati fatturazione</mat-card-title>
    <ct-form *ngIf="invoiceConfiguration" [configuration]="invoiceConfiguration"></ct-form>


    <div *ngIf="typeValue === TaskType.ResearchSelection">

      <div *ngFor="let taskLeadConfig of taskLeadConfigurations; let i = index" class="task-lead-form-container">

        <mat-card class="task-lead-form">

          <mat-card-title style="margin:11px">Aggiungi candidato</mat-card-title>

          <ct-form [configuration]="taskLeadConfig"></ct-form>
          <button style="margin:11px" mat-raised-button color="warn" (click)="removeTaskLeadForm(i)">Rimuovi</button>

        </mat-card>

      </div>

    </div>

    <mat-card-actions fxLayout="row wrap" fxLayoutAlign="space-between center">
      <ct-button [configuration]="cancelButton"></ct-button>
      <div>
        <ct-button *ngIf="typeValue === TaskType.ResearchSelection && this.isMasterDetail === false" [configuration]="addLeadButton"></ct-button>
        <!-- Pulsante Duplica Task - visibile solo in modalità edit (quando esiste un Oid) -->
        <app-task-clone *ngIf="isMasterDetail" [pid]="pId"></app-task-clone>
      </div>
      <ct-button [configuration]="submitButton"></ct-button>
    </mat-card-actions>

  </mat-card-content>

</mat-card>

<mat-card-title style="margin:20px" *ngIf="taskLeadModelConfiguration">Candidati</mat-card-title>

<ct-model *ngIf="taskLeadModelConfiguration" [configuration]="taskLeadModelConfiguration"></ct-model>